<template>
  <div class="container">
    <div
      v-for="(child, index) in list"
      :key="index"
    >
      <div
        class="hline hline-color"
        @click="() => handleExpand(child.year)"
      >
        <p class="title">{{child.year}}</p>
        <div class="line-container">
          <svg
            class="icon"
            :class="{'expand-icon': child.year == currentYear, 'collect-icon': child.year != currentYear}"
            aria-hidden="true"
          >
            <use xlink:href="#icon-you"></use>
          </svg>
        </div>
      </div>

      <div class="news-item-wrap">
        <div
          v-show="child.year == currentYear"
          v-for="item in child.newsList"
          :key="item.id"
          class="news-item"
        >
          <nuxt-link :to="localePath('/news/' + item.id)">
            <img
              v-lazy="item.img"
              :alt="item.name"
              src="~/assets/img/blank.png"
            />
            <p class="name">{{item.name}}</p>
            <p class="date">{{item.startDate}}—{{item.endDate}}</p>
          </nuxt-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      currentYear: String(new Date().getFullYear())
    }
  },
  computed: {
    ...mapState('news', ['list'])
  },
  methods: {
    handleExpand (year) {
      if (this.currentYear === year) {
        this.currentYear = -1
        return
      }

      this.currentYear = String(year)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;

  .hline {
    position: relative;
    margin-bottom: 60px;
    width: 100%;
    height: 1px;
    color: #000000;
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    cursor: pointer;

    .title {
      position: absolute;
      top: -10px;
      left: 50%;
      padding: 0 14px;
      background-color: #fff;
      transform: translate(-50%);
    }

    .line-container {
      position: absolute;
      top: -10px;
      right: 0;
      display: flex;
      align-items: center;
      padding-left: 14px;
      background-color: #fff;

      .button {
        color: #5e5e5e;
        font-size: 24px;
      }
    }
  }

  .expand-icon {
    animation: rotateTo 0.3s forwards;
  }

  .collect-icon {
    animation: rotateBack 0.3s forwards;
  }

  @keyframes rotateTo {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(90deg);
    }
  }

  @keyframes rotateBack {
    from {
      transform: rotate(90deg);
    }

    to {
      transform: rotate(0);
    }
  }

  .news-item-wrap {
    display: flex;
    flex-wrap: wrap;

    .news-item {
      margin-right: 40px;
      margin-bottom: 55px;
      width: 400px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: 240px;

        object-fit: contain;
      }

      .name {
        margin: 30px 0 20px;
        color: #000000;
        font-weight: bold;
        font-size: 22px;
        line-height: 32px;

        @include clamps-text-overflow(2);
      }

      .date {
        color: #5e5e5e;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;

        @include clamps-text-overflow(1);
      }
    }
  }
}
</style>
